<p>dashboard-global works!</p>
